"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devWarnings = require("../utils/devWarnings");

var _navUtils = require("./utils/navUtils");

var _sizes = require("HubStyleTokens/sizes");

var _UINavListItem = _interopRequireDefault(require("./UINavListItem"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _HR = _interopRequireDefault(require("../elements/HR"));

var _H = _interopRequireDefault(require("../elements/headings/H7"));

var hasPingedNewRelic = false;

var Ul = _styledComponents.default.ul.withConfig({
  displayName: "UINavList__Ul",
  componentId: "sc-8030i4-0"
})(["list-style:none;padding-left:0;margin-bottom:4px;line-height:16px;& .private-nav__wrapper{.private-nav-item{font-size:", ";padding-bottom:8px;padding-top:8px;padding-left:24px;}.private-folder-nav-item{padding-left:20px;}}", ""], _sizes.MICROCOPY_SIZE, function (_ref) {
  var depth = _ref.depth;
  return depth === 0 ? "margin-bottom: 0;" : "\n    .private-nav__wrapper .private-nav-item {\n      padding-left: " + 20 * (depth + 1) + "px;\n    }\n\n    .private-nav__wrapper {\n      ul {\n        margin-bottom: 0;\n      }\n    }\n    ";
});

var Nav = _styledComponents.default.nav.withConfig({
  displayName: "UINavList__Nav",
  componentId: "sc-8030i4-1"
})(["margin-bottom:20px;.private-nav__wrapper{margin-bottom:0;}"]);

var UINavList = (0, _createReactClass.default)({
  displayName: 'UINavList',
  propTypes: {
    children: _propTypes.default.node,
    depth: _propTypes.default.number,
    divider: _propTypes.default.bool,
    headingText: _propTypes.default.string,
    value: _propTypes.default.node,
    _rootComponent: _propTypes.default.func,
    _transformChildProps: _propTypes.default.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      depth: 0,
      value: null,
      _transformChildProps: function _transformChildProps() {
        return {};
      }
    };
  },
  rerenderFromRoot: function rerenderFromRoot(children) {
    if (children == null) return null;
    var _this$props = this.props,
        depth = _this$props.depth,
        value = _this$props.value,
        _rootComponent = _this$props._rootComponent,
        _transformChildProps = _this$props._transformChildProps;
    var Root = _rootComponent || UINavList;
    var props = {
      depth: depth + 1,
      value: value,
      _rootComponent: _rootComponent,
      _transformChildProps: _transformChildProps
    };
    return _react.default.createElement(Root, props, children);
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        depth = _this$props2.depth,
        divider = _this$props2.divider,
        headingText = _this$props2.headingText,
        __rootComponent = _this$props2._rootComponent,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "depth", "divider", "headingText", "_rootComponent", "value"]);
    var classes = (0, _classnames.default)(className, 'private-nav__wrapper');
    return _react.default.createElement(Nav, Object.assign({}, rest, {
      className: classes
    }), divider && _react.default.createElement(_HR.default, null), headingText && _react.default.createElement(_H.default, null, headingText), _react.default.createElement(Ul, {
      depth: depth
    }, _react.Children.map(children, function (child) {
      if (!_react.default.isValidElement(child)) {
        return child;
      }

      var defaultOpen = child && child.props && child.props.defaultOpen;

      if (child.type === _HR.default || child.type === _H.default) {
        return child; // to prevent a console warning as a result of UISideNav having H7 or HR as children
      } else if ( // Converts buttons, links, and a tags to `UINavListItem`s
      child.type === _UIButton.default || child.type === _UILink.default || child.type === 'a') {
        var _child$props = child.props,
            __children = _child$props.children,
            __useNativeButton = _child$props._useNativeButton,
            otherProps = (0, _objectWithoutProperties2.default)(_child$props, ["children", "_useNativeButton"]);

        _devLogger.default.warn({
          message: "UISideNav: Using a UIButton, UILink, or an <a> as a child is deprecated. " + "Use a `UISideNavItem` instead.",
          key: "UISideNav"
        });

        if (window.newrelic && !hasPingedNewRelic) {
          window.newrelic.addPageAction('deprecated-nav-child', {
            type: typeof child.type === 'string' ? child.type : (0, _getComponentName.default)(child.type)
          });
          hasPingedNewRelic = true;
        }

        return _react.default.createElement(_UINavListItem.default, Object.assign({
          active: (0, _navUtils.isChildActive)(child, value),
          defaultOpen: defaultOpen || (0, _navUtils.containsActiveChild)(child, value),
          href: child.props.href,
          onClick: child.props.onClick,
          title: child.props.children,
          value: undefined,
          _rootRenderer: _this.rerenderFromRoot
        }, otherProps));
      }

      (0, _devWarnings.warnIfFragment)(child, UINavList.displayName);
      return (0, _react.cloneElement)(child, {
        active: (0, _navUtils.isChildActive)(child, value),
        defaultOpen: defaultOpen || (0, _navUtils.containsActiveChild)(child, value),
        value: undefined,
        _rootRenderer: _this.rerenderFromRoot
      });
    })));
  }
});
var _default = UINavList;
exports.default = _default;
module.exports = exports.default;